export default __webpack_public_path__ + "static/media/T500_RoHS.edd27c8d.pdf";